"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_TYPES_MAP = exports.ACTION_TYPES = void 0;
exports.ACTION_TYPES = {
    CLICK: 'click',
    DBL_CLICK: 'dblClick',
    MOUSE_IN: 'mouseenter',
    MOUSE_OUT: 'mouseleave',
    CHANGE: 'change',
    BLUR: 'blur',
    FOCUS: 'focus',
    IMAGE_CHANGED: 'imageChanged',
    IMAGE_EXPANDED: 'imageExpanded',
    ON_INPUT: 'onInput',
    ITEM_CLICKED: 'itemClicked',
    CELL_SELECT: 'cellSelect',
    CELL_EDIT: 'cellEdit',
    ROW_SELECT: 'rowSelect',
    FETCH_DATA: 'fetchData',
    DATA_CHANGE: 'dataChange',
    ON_TIMEOUT: 'onTimeout',
    ON_VERIFY: 'onVerified',
    ON_ERROR: 'onError',
    ON_PLAY: 'onPlay',
    ON_PAUSE: 'onPause',
    ON_PROGRESS: 'onProgress',
    ON_ENDED: 'onEnded',
    AUTOPLAY_OFF: 'autoplayOff',
    AUTOPLAY_ON: 'autoplayOn',
    PLAY_ENDED: 'playEnded',
    PLAY_PROGRESS: 'playProgress',
    KEY_PRESS: 'keyPress',
    KEY_UP: 'keyUp',
    KEY_DOWN: 'keyDown',
    SCREEN_IN: 'screenIn',
    VIEWPORT_ENTER: 'viewportEnter',
    VIEWPORT_LEAVE: 'viewportLeave',
    SCROLL: 'scroll',
    VALIDATE: 'validate',
    SET_CUSTOM_VALIDITY: 'setCustomValidity',
    SYNC_VALIDATION_DATA: 'syncValidationData',
    UPDATE_VALIDITY_INDICATION: 'updateValidityIndication',
    MESSAGE: 'message',
    UPLOAD_COMPLETE: 'uploadComplete',
    ITEM_READY: 'itemReady',
    ITEM_REMOVED: 'itemRemoved',
    TAG_CLICK: 'tagClick',
    QUICK_ACTION_BAR_ITEM_CLICKED: 'quickActionBarItemClicked',
    GOOGLE_MAP_MARKER_CLICKED: 'markerClicked',
    GOOGLE_MAP_CLICKED: 'mapClicked',
    ICON_MOUSE_IN: 'iconMouseIn',
    ON_STATE_CHANGE: 'onStateChange',
    ITEM_MOUSE_IN: 'itemMouseIn',
    ITEM_MOUSE_OUT: 'itemMouseOut',
    ITEM_MOUSE_CLICK: 'itemMouseClick',
    ITEM_MOUSE_DOUBLE_CLICK: 'itemMouseDblClick',
    ON_COLOR_CHANGE: 'onColorChange',
    ON_FONT_CHANGE: 'onFontChange',
    ON_OPACITY_CHANGE: 'onOpacityChange',
};
// This map is used to translate velo SDK event names to component props.
// It is also consumed in Thunderbolt.
exports.EVENT_TYPES_MAP = {
    [exports.ACTION_TYPES.CLICK]: 'onClick',
    [exports.ACTION_TYPES.DBL_CLICK]: 'onDblClick',
    [exports.ACTION_TYPES.MOUSE_IN]: 'onMouseIn',
    [exports.ACTION_TYPES.MOUSE_OUT]: 'onMouseOut',
    [exports.ACTION_TYPES.CHANGE]: 'onChange',
    [exports.ACTION_TYPES.ON_INPUT]: 'onInput',
    [exports.ACTION_TYPES.BLUR]: 'onBlur',
    [exports.ACTION_TYPES.FOCUS]: 'onFocus',
    [exports.ACTION_TYPES.IMAGE_CHANGED]: 'onCurrentItemChanged',
    [exports.ACTION_TYPES.IMAGE_EXPANDED]: undefined,
    [exports.ACTION_TYPES.ITEM_CLICKED]: 'onItemClicked',
    [exports.ACTION_TYPES.CELL_SELECT]: 'onCellSelect',
    [exports.ACTION_TYPES.CELL_EDIT]: undefined,
    [exports.ACTION_TYPES.ROW_SELECT]: 'onRowSelect',
    [exports.ACTION_TYPES.FETCH_DATA]: undefined,
    [exports.ACTION_TYPES.DATA_CHANGE]: 'onDataChange',
    [exports.ACTION_TYPES.ON_TIMEOUT]: 'onTimeout',
    [exports.ACTION_TYPES.ON_VERIFY]: 'onVerified',
    [exports.ACTION_TYPES.ON_ERROR]: 'onError',
    [exports.ACTION_TYPES.ON_PLAY]: 'onPlay',
    [exports.ACTION_TYPES.ON_PAUSE]: 'onPause',
    [exports.ACTION_TYPES.ON_PROGRESS]: 'onProgress',
    [exports.ACTION_TYPES.ON_ENDED]: 'onEnded',
    [exports.ACTION_TYPES.AUTOPLAY_OFF]: 'onPause',
    [exports.ACTION_TYPES.AUTOPLAY_ON]: 'onPlay',
    [exports.ACTION_TYPES.PLAY_ENDED]: undefined,
    [exports.ACTION_TYPES.PLAY_PROGRESS]: undefined,
    [exports.ACTION_TYPES.KEY_PRESS]: 'onKeyPress',
    [exports.ACTION_TYPES.KEY_UP]: 'onKeyUp',
    [exports.ACTION_TYPES.KEY_DOWN]: 'onKeyDown',
    [exports.ACTION_TYPES.SCREEN_IN]: undefined,
    [exports.ACTION_TYPES.VIEWPORT_ENTER]: 'onViewportEnter',
    [exports.ACTION_TYPES.VIEWPORT_LEAVE]: 'onViewportLeave',
    [exports.ACTION_TYPES.SCROLL]: undefined,
    [exports.ACTION_TYPES.VALIDATE]: undefined,
    [exports.ACTION_TYPES.SET_CUSTOM_VALIDITY]: undefined,
    [exports.ACTION_TYPES.SYNC_VALIDATION_DATA]: undefined,
    [exports.ACTION_TYPES.UPDATE_VALIDITY_INDICATION]: undefined,
    [exports.ACTION_TYPES.MESSAGE]: 'onMessage',
    [exports.ACTION_TYPES.UPLOAD_COMPLETE]: undefined,
    [exports.ACTION_TYPES.ITEM_READY]: 'onItemReady',
    [exports.ACTION_TYPES.ITEM_REMOVED]: 'onItemRemoved',
    [exports.ACTION_TYPES.TAG_CLICK]: undefined,
    [exports.ACTION_TYPES.QUICK_ACTION_BAR_ITEM_CLICKED]: 'onItemClicked',
    [exports.ACTION_TYPES.GOOGLE_MAP_MARKER_CLICKED]: 'onMarkerClicked',
    [exports.ACTION_TYPES.GOOGLE_MAP_CLICKED]: 'onMapClicked',
    [exports.ACTION_TYPES.ICON_MOUSE_IN]: undefined,
    [exports.ACTION_TYPES.ON_STATE_CHANGE]: 'onStateChange',
    [exports.ACTION_TYPES.ITEM_MOUSE_IN]: 'onItemMouseIn',
    [exports.ACTION_TYPES.ITEM_MOUSE_OUT]: 'onItemMouseOut',
    [exports.ACTION_TYPES.ITEM_MOUSE_CLICK]: 'onItemClick',
    [exports.ACTION_TYPES.ITEM_MOUSE_DOUBLE_CLICK]: 'onItemDblClick',
    [exports.ACTION_TYPES.ON_COLOR_CHANGE]: 'onColorChange',
    [exports.ACTION_TYPES.ON_FONT_CHANGE]: 'onFontChange',
    [exports.ACTION_TYPES.ON_OPACITY_CHANGE]: 'onOpacityChange',
};
//# sourceMappingURL=eventTypes.js.map